export default {
    ARS: "ars",
    KIOSK: "kiosk",
    ZADP: "zadp",
    WEB: "web",
    MOBILE: "mobile",
    ZWEB: "zweb_display",
    ZPFC: "zpfc",
    ZPO: "zpo",
    ADR: "adr",
    ORDER: "order"
};
